import { Controller } from '@hotwired/stimulus';

/* global Cifra, Mn, $, _ */
Cifra.Components.FormAlumnoPendientes = Mn.View.extend({
  template: _.noop,
  events: {
    'change .alumno_pendiente_evaluacion_id': 'onEvaluacionChanged',
  },
  onRender() {
    // const view = this;
  },
  onEvaluacionChanged(e) {
    const $asignatura = $(e.currentTarget).parent().find('.alumno_pendiente_asignatura_id input').val();
    this._onEvaluacionChanged($asignatura, $(e.currentTarget).find('select').val());
  },
  _onEvaluacionChanged($asignatura, $evaluacion) {
    const view = this;
    const $modal = view.$el.closest('.modal');
    const $alumno = view.$('#alumno_pendiente_alumno_id').val();
    const params = {
      asignatura_id: $asignatura,
      evaluacion_id: $evaluacion,
    };
    $modal.css('z-index', '150');
    $.get(`/alumno_pendientes/${$alumno}/nota_asignatura`, params, (data) =>{
      view.$(`input[name="alumno_pendiente[${$asignatura}][valor]"]`).val(data.valor);
      view.$(`textarea[name="alumno_pendiente[${$asignatura}][observaciones]"]`).val(data.observaciones);
      $modal.css('z-index', '1050');
    });
  },
});

export default class FormAlumnoPendientes extends Controller {
  connect() {
    this.component = new Cifra.Components.FormAlumnoPendientes(
      { el: this.element },
    );
    this.component.render();
  }
}
